// app constant
export const authentication = {
  ssoAuthType: 'sso',
  selfAuthType: 'self',
};

// cookies constant
export const user = {
  user:'creator_user',
  selfToken: 'selfToken',
  ssoToken: 'ssoToken',
  authType: 'authType',
  appToken: 'appToken',
};